import { Flex, Switch, Text } from "shared/components/Spor";
import { FC, useContext } from "react";
import { Service50Icon } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/ServiceFill50Icon";
import { useTheme } from "styled-components";
import { MeasureOverviewStateContext } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewStateContext";

export const MeasureOverviewHeader: FC = () => {
  const theme = useTheme();
  const { compact, toggleCompact, showClosed, toggleShowClosed } = useContext(
    MeasureOverviewStateContext,
  );
  return (
    <Flex
      direction="row"
      gap={3}
      justifyContent="space-between"
      alignItems="center"
    >
      <Flex gap={2} alignItems="center">
        <Service50Icon color={theme.colorIconMain} />
        <Text variant="lg" as="h1">
          Tiltaksoversikt
        </Text>
      </Flex>

      <Flex gap={2}>
        <Flex gap={1.5}>
          <Switch
            checked={compact}
            onCheckedChange={toggleCompact}
            margin={0}
          />
          <Text>Kompakt visning</Text>
        </Flex>

        <Flex gap={1.5}>
          <Switch checked={showClosed} onCheckedChange={toggleShowClosed} />
          <Text>Vis friskmeldte</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
